/*
 * Module for the content mapping modal, which is basically just the contentMapping module
 * inside a modal with OK and Cancel buttons
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/shared/contentMappingModal/contentMappingModalView",
  "modules/shared/contentMapping/contentMappingModule",
], function (Marionette, $, Messenger, ContentMappingModalView, ContentMappingModule) {
  var ContentMappingModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentMappingModal";
      this.region = options.region;
      this.selectedContent = null;
      this._setUpVents();
    },
    show: function (conversation) {
      this.conversation = conversation;
      this.layout = new ContentMappingModalView.contentMappingModalLayout();
      this.layout.on(
        "done",
        function () {
          if (this.selectedContent !== null) {
            conversation.setAssociatedContent(this.selectedContent);
            Messenger.vent.trigger("close:modal");
          } else {
            //no content selected, so show an error
            this.contentError($.t("topic.responseProperties.contentError"));
          }
        },
        this,
      );
      this.layout.on(
        "cancel",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.contentMappingArea = this.addSubModule(
        new ContentMappingModule({ region: this.layout.contentMappingArea }),
      );
      this.showRegion(this.layout);
    },
    clearError: function () {
      this.layout.clearError();
    },
    contentError: function (errorMessage) {
      this.layout.contentError(errorMessage);
    },
    _showSubViews: function () {
      this.contentMappingArea.show();
    },
    _setUpVents: function () {
      //handle when we select a piece of content
      Messenger.vent.on(
        "list:item:selected",
        function (model) {
          this.selectedContent = model;
        },
        this,
      );

      //User selected content via the typeahead search, so select the content and close the modal
      Messenger.vent.on(
        "mapping:search:selected",
        function (model) {
          this.selectedContent = model;
          this.layout.trigger("done");
        },
        this,
      );
    },
  });

  return ContentMappingModalController;
});
